/*
 *
 * DashboardHome action/reducer
 *
 */

import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  removeToken,
  goToSecuritySettings,
  getTnCForCidpUser,
  setUserAcceptedNewTnC,
} from "scenes/redux";
import { Application, Applications } from "types/Dashboard";
import { createActionDispatchers } from "utils/reduxHelpers";

export type State = {
  loading: boolean;

  loadingCheckOnUpdatedTnc: boolean;
  hasUpdatedTnCFromPartner: boolean;

  loadingUpdatedTnC: boolean;
  newTnC: string | null;

  hasUpdatedTnCAccepted: boolean;

  tncForCIDPUser: string | null;

  showError: boolean;

  loadingApplications: boolean;
  applications: {
    [key: string]: Array<Application>;
  } | null;
};

export const initialState: State = {
  loading: false,
  loadingCheckOnUpdatedTnc: false,
  hasUpdatedTnCFromPartner: false,

  loadingUpdatedTnC: false,
  newTnC: null,

  hasUpdatedTnCAccepted: false,

  showError: false,

  tncForCIDPUser: null,

  loadingApplications: false,
  applications: {},
};

const slice = createSlice({
  name: "dashboard",
  initialState,
  // create actions with reducer (slice action) here
  reducers: {
    setError(state: State, action: PayloadAction<boolean>) {
      state.showError = action.payload;
    },

    getApplications(state: State) {
      state.loadingApplications = true;
    },

    afterApplicationsLoad(state: State, action: PayloadAction<Applications>) {
      state.loadingApplications = false;
      state.applications = action.payload.applications;
    },
  },
});

/**
 * create actions WITHOUT reducer (pure action) here
 */

/**
 * actions from slice to be exported for saga
 */
export const { setError, getApplications, afterApplicationsLoad } =
  slice.actions;

/**
 * all actions for layout
 */
export const actionProps = createActionDispatchers(
  slice.actions,
  // slice actions
  ["getApplications"],
  {
    removeToken,
    goToSecuritySettings,
    getTnCForCidpUser,
    setUserAcceptedNewTnC,
  }
);

export default slice.reducer;
